import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Github, Linkedin, Twitter } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gradient-to-r from-[#0EA5E9] to-[#3B82F6] text-white">
      <div className="container mx-auto py-12 px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-xl font-bold mb-4">Talento AI</h3>
            <p className="mb-4">
              Bridging human talent with AI automation for the future of work.
            </p>
            <div className="flex space-x-4">
              <a href="https://twitter.com/talento_ai" target="_blank" rel="noopener noreferrer" className="hover:text-white/80">
                <Twitter size={20} />
              </a>
              <a href="https://linkedin.com/company/talento-ai-inc" target="_blank" rel="noopener noreferrer" className="hover:text-white/80">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-white/80">Home</Link></li>
              <li><Link to="/about" className="hover:text-white/80">About Us</Link></li>
              <li><Link to="/join-waitlist" className="hover:text-white/80">Join Waitlist</Link></li>
              <li><Link to="/contact" className="hover:text-white/80">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/ai-agent-development" className="hover:text-white/80">AI Agent Development</Link></li>
              <li><Link to="/sop-automation" className="hover:text-white/80">SOP Automation</Link></li>
              <li><Link to="/talent-recruitment" className="hover:text-white/80">Talent Recruitment</Link></li>
              <li><Link to="/ai-training" className="hover:text-white/80">AI Training</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Mail size={16} className="mr-2" />
                <a href="mailto:info@talento-ai.com" className="hover:text-white/80">contact@talento-ai.com</a>
              </li>
              <li className="flex items-center">
                <Phone size={16} className="mr-2" />
                <a href="tel:+18176164295" className="hover:text-white/80">+1(817)-616-4295 </a>
              </li>
              <li className="flex items-start">
                <MapPin size={16} className="mr-2 mt-1" />
                <span>304 S. Jones Blvd, Las Vegas, NV, 89107</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p>© {currentYear} Talento AI. All rights reserved. | <a href="https://talento-ai.com" className="hover:text-white/80">talento-ai.com</a></p>
        </div>
      </div>
    </footer>;
};
export default Footer;